import { Icon, IconProps } from './Icon'

export function Play({ size = 24, className = '', strokeWidth = 2, color = 'currentColor' }: Omit<IconProps, 'children'>) {
  return (
    <Icon size={size} className={className} strokeWidth={strokeWidth} color={color}>
      <polygon points="5,3 19,12 5,21" />
    </Icon>
  )
}
